import { AxiosError } from 'axios';

/**
 * Represents an exception that occurred on the server and was passed to the client
 */
export interface ServerException {
	/**
	 * Specifies the type of exception that occurred on the server. If this is populated it means the exception is res
	 */
	exceptionCode?: string;

	/**
	 * The error message to display to the end user. If this is an unhandled exception, the message in general
	 */
	message: string;

	/**
	 * The detailed exception information from the server. If the server is in release mode or the exception can be handled (exceptionCode isn't null) then this field will be undefined. It should not be relied on outside of debugging.
	 */
	exception?: ExceptionDto;
}

/**
 * Retrieves the handleable exception from an axios error if one exists
 */
export function getHandleableException(error: any) {
	const axiosError: AxiosError = error;

	const serverException: ServerException | undefined = axiosError.response && axiosError.response.data;

	if (serverException && serverException.exceptionCode) {
		return serverException;
	}

	return undefined;
}

/**
 * The detailed exception information from the server. Only ever used when running in debug mode.
 */
export interface ExceptionDto {
	stackTrack: string;
	source: string;
	message: string;
	innerException?: ExceptionDto;
}

///////////////////////
// Removal Exception //
///////////////////////

/**
 * The reason a removal request failed (eg. soft deletion, hard deletion, deactivation)
 */
export enum RemovalFailureReason {
	CannotForce = 'CannotForce',
	WasNotForced = 'WasNotForced',
}

/**
 * The severity of a removal request. A higher severity indicates that the user should be slowed down to stop them from shooting themselves in the foot.
 */
export enum RemovalSeverity {
	Normal = 'Normal',
	Warning = 'Warning',
	Danger = 'Danger',
}

/** Exception originiating from the server indicating that a request for a removal (soft deletion, hard deletion, or deactivation) failed. */
export interface RemovalException extends ServerException {
	failureReason: RemovalFailureReason;
	removalSeverity: RemovalSeverity;
}
